export function formatDateAsString(date?: number): string {
  if (!date) return ''

  const dateObj = new Date(date)
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }

  return dateObj.toLocaleDateString('de-DE', options) // Using 'de-DE' locale for 'DD.MM.YYYY' format
}
